

import Axios from 'axios';
var data = {
  list: [],// init后列表
  itemDataCache: {},// init后, 以id为key的对象组
  init: function(res){// [{}]
    data.list = res || [];
    var ary = data.list;
    for(var i=0;i<ary.length;i++){
      data.itemDataCache[ary[i].dataValue] = ary[i];
      // // debugger
    }
  },
 
  submit(params, callback){
    Axios.post("/cat/api/v1/user/update", params).then((response) => {
// debugger
if (!response) {
  return
}
      callback&&callback(response);

    }).catch((error) => {

      // Message({
      //   message: "网络出错!",
      //   type: "error"
      // });
      // console.log(error);

    });
  },
  toDataAry(ary){// 根据名字组, 转成提交格式
    var result = [];
    if(ary){
      for(var i=0;i<ary.length;i++){
        if(this.itemDataCache[ary[i]]){
          result.push({
            domainCode: this.itemDataCache[ary[i]].dataKey,
            domainName: this.itemDataCache[ary[i]].dataValue,
          });
        }
      }
    }
    return result;
    },
  toDataAry_ly(ary){// 根据提交格式, 转成名字组
    var result = [];
    if(ary){
      for(var i=0;i<ary.length;i++){
        if(ary[i]){
          result.push(ary[i].domainName);
        }
      }
    }
    return result;
  },
  // toIdAry(ary){
  //   var result = [];
  //   if(ary){
  //     for(var i=0;i<ary.length;i++){
  //       result.push(data.itemDataCache[ary[i]].id);
  //     }
  //   }
  //   return result;
  // },
};

export default data;